const INITIAL_STATE = {
    orderInfo: null
}

export const INIT = '__INIT__'

const orderScreenReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT:
            return {
                ...state,
                orderInfo: action.orderInfo
            }
        default:
            return { ...state }
    }
}

export default orderScreenReducer